<template>
  <div>
    <router-view></router-view>
    <!-- 在页面底部添加备案号 -->
    <footer
      style="
        text-align: center;
        padding: 10px;
        background-color: #f9f9f9;
        font-size: 14px;
      "
    >
      <p>
        © 2026 诠信全译智能科技（上海）有限公司
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #555; text-decoration: none"
        >
          沪ICP备2026002871号
        </a>
      </p>
    </footer>
  </div>
</template>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

::view-transition-old(root),
::view-transition-new(root) {
  animation: none;
}
.dark::view-transition-old(root) {
  z-index: 9999;
}
</style>
